/* eslint-disable */
import {
  Button,
  Checkbox,
  Flex,
  message,
  Modal,
  Popover,
  Radio,
  Space,
  Dropdown,
  Menu,
  Input,
  Form,
  Select,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "../UserList.css";
import {
  CaretDownOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  OneToOneOutlined,
  PlusOutlined,
  SyncOutlined,

  VerticalAlignBottomOutlined,
} from "@ant-design/icons";
import MainTable from "./component/MainTable";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { Link } from "react-router-dom";
const { TextArea } = Input;
export default function UserList() {
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [delList, setDelList] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [form, formEmail] = Form.useForm();
  const [isSelectVisible, setIsSelectVisible] = useState(false);
  const childRef = useRef();
  const [tableHead, setTableHead] = useState({
    status: "open",
    remark: null,
    assignedToName: null,
    PropUnit: null,
    unitStatus: null,
    propType: null,
    units: null,
    unitAddress: null,
    city: null,
    sCompletedTime: null,
    eCompletedTime: null,
    groupSupervisor:null
  });
  const deleteNum = (num) => {
    console.log(num);
    setDelList(num);
  };
  //调用子组件showModal方法
  const showModal = () => {
    if (childRef.current) {
      // childRef.current.showModal();
    }
  };
  const showModalThree = () => {
    console.log("==========刷新按钮============");
    if (childRef.current) {
      childRef.current.newListFun();
    }
  };
  const showModalTwo = () => {
    console.log("==========childRef.current============");
    console.log(childRef.current);
    if (childRef.current) {
      childRef.current.newListFun();
    }
  };
  //  下载
  const DownloadBtn = () => {
    Modal.confirm({
      title: "You are exporting Data based on Created DateRange. Are you sure you want to download the data?",
      icon: <ExclamationCircleOutlined />,

      okText: "Sure",
      cancelText: "Cancel",
      async onOk(tableHead) {
        setLoading(true);
        try {
          if (childRef.current) {
            console.log(childRef.current);
            if (typeof childRef.current.getSearchValues === "function") {
              const inputValues = childRef.current.getSearchValues();
              console.log("Search Values:", inputValues);
              setTableHead((prev) => ({
                ...prev,
                ...inputValues,
              }));
              const queryParams = new URLSearchParams({
                status: tableHead?.status || "open",
                groupSupervisor: inputValues.groupSupervisor || "",
                remark: inputValues.remark || "",
                assignedToName: inputValues.assignedToName || "",
                propUnit: inputValues.propUnit || "",
                unitStatus: inputValues.unitStatus || "",
                propType: inputValues.propType || "",
                units: inputValues.units || "",
                unitAddress: inputValues.unitAddress || "",
                city: inputValues.city || "",
                sCompletedTime: tableHead?.sCompletedTime || "",
                eCompletedTime: tableHead?.eCompletedTime || "",
              });
          
              const response = await http.get(
                `${api.getToExcel}?${queryParams.toString()}`,
                {
                  responseType: "blob",
                }
              );

              if (response instanceof Blob) {
                const url = window.URL.createObjectURL(response);

                const link = document.createElement("a");
                link.href = url;

                // 获取当前日期并格式化为 MM-dd-yyyy
                const today = new Date();
                const month = String(today.getMonth() + 1).padStart(2, "0");
                const day = String(today.getDate()).padStart(2, "0");
                const year = today.getFullYear();
                const formattedDate = `${month}-${day}-${year}`;

                const filename = `NonMaintenance_Request_${formattedDate}.xlsx`;
                link.setAttribute("download", filename);

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                message.success("File downloaded successfully.");
              } else {
                throw new Error(
                  "Invalid response from server: Expected a Blob"
                );
              }
            }
          }
        } catch (error) {
          console.error("Error:", error);
          message.error("An error occurred. Please try again.");
        } finally {
          setLoading(false);
        }
      },
      onCancel() {
        console.log("Cancel");
      },
      style: {
        top: "40%",
      },
    });
  };
  //complete request
  const completeBtn = () => {
    console.log("选中数据", delList);
    if (delList.length === 1) {
      Modal.confirm({
        title: "Complete Request",
        icon: <ExclamationCircleOutlined />,
        content: (
          <Form form={form}>
            <Form.Item name="completedForm">
              <Input.TextArea placeholder="Input at least 5 words" />
            </Form.Item>
          </Form>
        ),
        okText: "Sure",
        cancelText: "Cancel",
        async onOk() {
          setLoading(true);
          try {
            const values = await form.validateFields();
            const CompleteData = {
              id: delList[0].id,
              status: "completed",
              completedBy: localStorage.getItem("accountId"), // Use localStorage or provide a mock
              completedRemark: values.completedForm,
            };
            console.log("CompleteDataparams", CompleteData);
            const response = await http.post(
              api.completeRequestData,
              CompleteData
            );
            if (response && response.code == 1) {
              message.success("Successfully updated.");
              childRef.current.newListFun();
              form.resetFields();
            }
          } catch (error) {
            message.error("An error occurred. Please try again.");
          } finally {
            setLoading(false);
            form.resetFields();
          }
        },
        onCancel() {
          console.log("Cancel");
          form.resetFields();
        },
        style: {
          top: "40%",
        },
      });
    } else if (delList.length < 1) {
      message.warning("Please select one piece of data."); //请先选择要删除的数据
    } else if (delList.length > 1) {
      message.warning("Please select one piece of data."); //请先选择要删除的数据
    }
  };

  const toEmailBtn = () => {
    console.log("选中数据", delList);
    if (delList.length === 1) {
      Modal.confirm({
        title: "Email",
        icon: <ExclamationCircleOutlined />,
        content: (
          <Form form={form}>
            <Form.Item name="EmailForm">
              <Input.TextArea placeholder="Please enter a valid email address" />
            </Form.Item>
          </Form>
        ),
        okText: "Sure",
        cancelText: "Cancel",
        async onOk() {
          setLoading(true);
          try {
            const values = await form.validateFields();
            const response = await http.get(`${api.getToEamil}?nonMaintenanceId=${delList[0].id}&toEmail=${values.EmailForm}`);
          
            if (response && response.code == 1) {
              message.success("Email sent successfully.");
              childRef.current.newListFun();
              form.resetFields();
            }else if(response && response.code == 0){
              message.error(response.msg);
            }
          } catch (error) {
            message.error("An error occurred. Please try again.");
          } finally {
            setLoading(false);
            form.resetFields();
          }
        },
        onCancel() {
          console.log("Cancel");
          form.resetFields();
        },
        style: {
          top: "40%",
        },
      });
    } else if (delList.length < 1) {
      message.warning("Please select one piece of data."); //请先选择要删除的数据
    } else if (delList.length > 1) {
      message.warning("Please select one piece of data."); //请先选择要删除的数据
    }
  };
  // 指定人员
  // 获取account 值
  const getSearchAccount = async () => {
    try {
      const response = await http.get(`${api.searchAccountType}`);
      if (response && response.data) {
        const formattedData = response.data.map((item) => ({
          value: item.accountId, // 使用 accountId 作为 value
          label: item.roleAllName, // 使用 roleAllName 作为 label
        }));
        setAccountData(formattedData);

      }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
      setLoading(false);
    }
  };

  const handleDivClick = () => {
    setIsSelectVisible(true);
  };
  const handleClear = () => {
    setSelectedAccount(null);
  };
  const handleChangeUpdata = (value, e) => {
    setSelectedAccount(value);
    console.log("选中数据", delList);
    if (delList.length === 1) {
      Modal.confirm({
        title: "Assign Reminder",
        icon: <ExclamationCircleOutlined />,
        content: "Are you sure assign to this people?",
        okText: "Sure",
        cancelText: "Cancel",
        async onOk() {
          //确认指定
          setSelectedAccount(value);
          console.log(`Selected: ${value}`);
          try {
            const updateData = {
              id: delList[0].id,
              assignedTo: value,
            };
            console.log(updateData);
            const response = await http.post(api.getUpdate, updateData);
            if (response && response.code == 1) {
              message.success("Successfully updated.");
              childRef.current.newListFun();
              setDelList([]);

              setSelectedAccount(null);
            } else {
              message.error("An error occurred. Please try again.");
            }
          } catch (error) {
            message.error("An error occurred. Please try again.");
          } finally {
            setLoading(false);
          }
        },
        onCancel() {
          console.log("Cancel");
          setSelectedAccount(null);
        },
        style: {
          top: "40%",
        },
      });
    } else if (delList.length < 1) {
      message.warning("Please select one piece of data."); 
    } else if (delList.length > 1) {
      message.warning("Please select one piece of data."); 
    }
  };

  // 处理选项变化
  const handleChange = (checkedValues) => {
    console.log(checkedValues);
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        {/* 使用 Space 的 direction="vertical" 来让复选框垂直排列 */}
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );
  const content2 = <a>Export to CSV</a>;

  // 获取子组件的值
  const getTableHead = () => {
    const list = childRef.current.getValue();
    setColumns(list);
    const transformedList = list.map((item) => ({
      label: item.dataIndex,
      value: item.key,
    }));

    setOptions(transformedList);
    const transformedList2 = list.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  useEffect(() => {
      // 如果 token 存在，调用 getSearchAccount 函数
      getTableHead();
      getSearchAccount();
  }, []);
  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div className="topLeft">
          {commonFn.btnAuthorityFlag('NewRequest') && <Space size="large">
            <Link
              target="_blank"
              to="/JobRequests/NonMaintenanceRequest/Add"
            >
              <Button className="btnNew" onClick={showModal}>
                <PlusOutlined />
                New Request
              </Button>
            </Link>
          </Space> || null}
          {commonFn.btnAuthorityFlag('CompleteRequest') && <Button style={{marginRight:"20px",}} color="cyan" variant="solid" onClick={completeBtn}>
            Complete Request
          </Button> || null}

          {commonFn.btnAuthorityFlag('AssignTo') && <Select
            showSearch
            style={{ width: 300, padding: 0,  marginRight:"20px"}}
            placeholder="Assign To"
            optionFilterProp="children"
            onChange={handleChangeUpdata}
            onClear={handleClear}
            allowClear
            onBlur={() => setIsSelectVisible(false)}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            value={selectedAccount || undefined}
            options={accountData}
            loading={loading}
          /> || null}

          {commonFn.btnAuthorityFlag('SendEmail') && <Button color="orange" variant="solid" onClick={toEmailBtn} danger>
           Send Email
          </Button> || null}

          {/* </div> */}
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
            {commonFn.btnAuthorityFlag('Download') && <Radio.Button value="c" onClick={DownloadBtn}>
              <Popover title="" trigger="click">
                <VerticalAlignBottomOutlined />
              </Popover>
            </Radio.Button> || null}
          </Radio.Group>
        </div>
      </Flex>
      <MainTable ref={childRef} deleteNum={deleteNum}></MainTable>
    </div>
  );
}
